import {getAuthHeaders, getCookie, restApiEndpoint} from '../../utils/common'
import Axios from 'axios';

let endpoint = restApiEndpoint();

const testSMS =  async (phoneNumber) => {
  const headers = getAuthHeaders();
  const response = await Axios.post(`${endpoint}/sendtesttextmessage?phonenumber=${phoneNumber}`, {}, {headers}).catch(() => {
    return null;
  });
  return response;
}

const cancelSubscription =  async (data) => {
  const headers = getAuthHeaders();
  const response = await Axios.post(`${endpoint}/subscription/cancelaccount`, data, {headers}).catch(() => {
    return null;
  });
  return response;
}

const deleteAccount =  async () => {
  const headers = getAuthHeaders();
  const response = await Axios.post(`${endpoint}/account/deleteallaccountinformation`, {}, {headers}).catch(() => {
    return null;
  });
  return response;
}

const submitStripeToken =  async (token) => {
  const headers = getAuthHeaders();
  const response = await Axios.post(`${endpoint}/subscription/updatepaymentinformation`, {}, {headers: {...headers, stripeToken: token}}).catch(() => {
    return null;
  });
  return response;
}

const postProfile =  async (data) => {
  const headers = getAuthHeaders();
  const response = await Axios.post(`${endpoint}/profile/update`, data, {headers}).catch(() => {
    return null;
  });
  return response;
}

const getProfile =  async () => {
  const headers = getAuthHeaders();
  const response = await Axios.get(`${endpoint}/profile/profile`, {headers}).catch(() => {
    return null;
  });
  return response && response.data;
}

const sendEmail =  async (email) => {
  const headers = getAuthHeaders();
  const response = await Axios.post(`${endpoint}/tpmconversion?emailaddress=${email}`, {}, {headers}).catch(() => {
    return null;
  });
  return response && response.data;
}

const getPayment = async () => {
  const headers = getAuthHeaders();
  const response = await Axios.get(`${endpoint}/subscription/getpaymentinformation`, {headers}).catch(() => {
    return null;
  });
  return response && response.data;
}

const getAccounts = async () => {
  const headers = getAuthHeaders();
  const response = await Axios.get(`${endpoint}/account/accounts`, {headers}).catch(() => {
    return null;
  });
  return response && response.data;
}

const getProfitLoss = async (type, data) => {
  const headers = getAuthHeaders();
  const response = await Axios.post(`${endpoint}/charts/${type}`, data, {headers}).catch(() => {
    return null;
  });
  return response && response.data;
}

const getTrades = async (data) => {
  const headers = getAuthHeaders();
  const response = await Axios.post(`${endpoint}/account/trades`, data, {headers}).catch(() => {
    return null;
  });
  return response && response.data;
}

const postMethod = async (url, data) => {
  const headers = getAuthHeaders();
  const response = await Axios.post(`${endpoint}${url}`, data, {headers});
  return response && response.data;
}

const getMethod = async (url) => {
  const headers = getAuthHeaders();
  const response = await Axios.get(`${endpoint}${url}`, {headers}).catch(() => {
    return null;
  });
  return response && response.data;
}

const getCommunicationDescription = async () => {
  const headers = getAuthHeaders();
  const response = await Axios.get(`${endpoint}/members/description/communicationreview`, {headers}).catch(() => {
    return null;
  });
  return response && response.data;
}

const getNewUserDescription = async () => {
  const headers = getAuthHeaders();
  const response = await Axios.get(`${endpoint}/members/description/newuserpopup`, {headers}).catch(() => {
    return null;
  });
  return response && response.data;
}

const getFreeTrialVisible = async () => {
  const headers = getAuthHeaders();
  const response = await Axios.get(`${endpoint}/product/freetrialvisible`, {headers}).catch(() => {
    return null;
  });
  return response && response.data;
}

const ApiService = {
  testSMS,
  cancelSubscription,
  deleteAccount,
  submitStripeToken,
  getProfile,
  postProfile,
  sendEmail,
  getPayment,
  getAccounts,
  getProfitLoss,
  getTrades,
  postMethod,
  getMethod,
  getCommunicationDescription,
  getNewUserDescription,
  getFreeTrialVisible
}

export default ApiService;


// WEBPACK FOOTER //
// ./src/actions/apiService/index.js